<template>

  <div class="main-container">

    <section  class="container mt-0 pt-0">

        <div class="row">

          <div class="col-12 offset-0 col-md-6 offset-md-3">

            <b-alert show variant="warning" class="my-5">
              <h4 class="alert-heading">You session has been cancelled.</h4>
              <p class="alert-warning">
                Please feel free to try again soon. <br>
                <b-button href="trackdDeeplink://" variant="outline-secondary" class="mt-3" >Return to app</b-button>
              </p>
            </b-alert>

          </div>

        </div>

      </section>

  </div>
  
</template>

<script>
  
  export default {
    name: 'Cancel',
    mounted: function () {
      window.location = 'trackdDeeplink://'
    }
  }

  //window.location = 'trackdDeeplink://'
  
</script>
